// The features below have all settled into their final states and the flags
// below can be removed when we get a chance.
export const reminders_in_message_action_menu = false;
